import Control from "./Control.js"

export default class Airplay extends Control {

  constructor(props, context) {
    super(props, context)
    this.state.available = false
    this.state.playing = false
    this.classList.add("amp-airplay", true)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get isAvailable() {
    return (window.WebKitPlaybackTargetAvailabilityEvent != null)
  }

  get available() {
    return (this.isAvailable && this.state.available)
  }

  set playing(value) {
    this.state.playing = value
    this.plugin.container.classList.update({"amp-playback-target-airplay": value})
  }

  get playing() {
    return this.state.playing
  }

  onready(event) {
    if (this.isAvailable === false)
      return

    const video = this.player.mediaElement
    video.setAttribute("x-webkit-airplay", "allow")
    video.addEventListener("webkitplaybacktargetavailabilitychanged", (event) => {
      this.state.available = (event.availability == "available")
      this.playing = video.webkitCurrentPlaybackTargetIsWireless
      this.forceUpdate()
    })
    window.addEventListener("webkitcurrentplaybacktargetiswireless", (event) => {
      this.playing = video.webkitCurrentPlaybackTargetIsWireless
    })
  }

  onClick() {
    this.player.mediaElement.webkitShowPlaybackTargetPicker()
  }

  render() {
    if (this.available === false)
      return null

    return super.render()
  }
}
